import './../css/popup.css';
import { IoIosClose } from "react-icons/io";

//==== POP UP LAYOUT =============
const PopUp = (props:any) => {

    return (props.trigger) ? (
        <div className="popup">
            <div className="popup_inner">
                <button 
                    className='popup_closebtn' 
                    onClick={()=> props.setTrigger(false)}><IoIosClose/></button>
                {props.children}
            </div>
        </div>
    ) : (<></>)

}

export default PopUp;